import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';
import { HisNavigationService } from '../service/base/his-navigation.service';
import { HisUiService } from '../service/base/his-ui.service';

export function hisCanDeactivate(): Observable<boolean> | boolean {
    let navigationService = inject(HisNavigationService);
    if (!navigationService.hasUnsavedChanges) {
        return of(true);
    }

    let uiService = inject(HisUiService);
    let message = uiService.translate('common.unsavedDataContinue');
    let start = Date.now();
    if (confirm(message)) {
        return true;
    } else {
        // if the confirm dialog was rejected within 10 milliseconds
        // it is safe to assume that the dialog was suppressed. 
        return Date.now() - start < 10;
    }
}